const currencies_by_url = {
  "royalessence.eu": "EUR",
  "royalessence.co.uk": "GBP",
  "ie.royalessence.com": "EUR",
  "royalessence.com.de": "EUR",
  "fr.royalessence.com": "EUR",
  "pt.royalessence.com": "EUR",
  "royalessence.nl": "EUR",
  "royalessence.com.es": "EUR",
  "royalessence.it": "EUR",
  "royalessence.be": "EUR",
  "royalessence.com": "USD",
  "royalessence.ca": "CAD",
  "royalessence.com.au": "AUD",
  "royalessence.co.nz": "NZD"
};

const currencies_by_symbol = {
  "royalessence.eu": "€",
  "royalessence.co.uk": "£",
  "ie.royalessence.com": "€",
  "royalessence.com.de": "€",
  "fr.royalessence.com": "€",
  "pt.royalessence.com": "€",
  "royalessence.nl": "€",
  "royalessence.com.es": "€",
  "royalessence.it": "€",
  "royalessence.be": "€",
  "royalessence.com": "$",
  "royalessence.ca": "$",
  "royalessence.com.au": "$",
  "royalessence.co.nz": "$"
}

function getCurrencyByUrl (raw_url)
{
  let url = raw_url.replace('www.', '');
  let currency_abbr = "USD";
  
  if (currencies_by_url[url] != undefined) 
    currency_abbr = currencies_by_url[url];
  
  return currency_abbr;
}

function getCurrencySymbolByUrl (raw_url)
{
  let url = raw_url.replace('www.', '');
  let currency_symbol = "$";
  
  if (currencies_by_symbol[url] != undefined) 
    currency_symbol = currencies_by_symbol[url];
  
  return currency_symbol;
}

$(document).ready(function(){
  
  const current_url = window.location.hostname;
  const store_currency = getCurrencyByUrl (current_url);
  
  const currency_symbol = getCurrencySymbolByUrl (current_url);
  
  const vault_box_currency_sign = document.getElementById ('vault-box-currency-sign');
  const vault_box_currency_abbr = document.getElementById ('vault-box-currency-abbr');
  
  vault_box_currency_abbr.innerHTML = store_currency;
  vault_box_currency_sign.innerHTML = currency_symbol;

  $('#codebox').submit(function(ev) {
    
    $(this).find(":submit").prop("disabled", true);

    /* VALIDATION */
    var globalVar = {};
    var enteredCode = $('#code').val().toLowerCase();
    var newArray = [];

    function draw(data, sheetrock, response) {
      globalVar.response = response;
      var str = response.html;
      newArray = str.replace(/<(.|\n)*?>/g, ',').split(",").filter(function(x){
        return (x !== (undefined || null || ''));
      }); 

      if(jQuery.inArray(enteredCode, newArray) !== -1) {
      } else {
        $("#slotbox").hide().css('display', 'none');
        $("#codebox").hide();
        $("#fieldError").show();
      } 
    }
    /* END VALIDATION */
    
    const column_letter_by_currency = {
      "AUD": "B",
      "NZD": "C",
      "USD": "D",
      "GBP": "E",
      "EUR": "F",
      "CAD": "G"
    }

    var re_sheetrock_query = "select " + column_letter_by_currency[store_currency] + " where A ='"+$('#code').val().toLowerCase()+"'";
    
    $('table#tab').sheetrock({
      url: "https://docs.google.com/spreadsheets/d/1KHW7aEwe94HyL2NvAvM1oXRyr21saERdhNNbv7RGtpc/edit#gid=843520838",
      query: re_sheetrock_query,
      callback: function (error, options, response) {
        if (error) {alert(error);}

        text = $('table#tab tr td').text(); // The message displayed

        if (!text){
          $("#slotbox").hide().css('visibility', 'hidden');
          $("#codebox").hide();
          $("#fieldError").show();
        }
        else{
          text = text.substring(1);
          text = text.replace(",", "");
          text = text.padStart(4, '0');
        }

        // SLOTBOX ANIMATION

        chars = '0123456789';  // All possible Charactrers
        let scale = 100;  // Font size and overall scale
        
        breaks = 0.003;  // Speed loss per frame
        endSpeed = 0.05;  // Speed at which the letter stops
        firstLetter = 220;  // Number of frames untill the first letter stops (60 frames per second)
        delay = 40;  // Number of frames between letters stopping

        canvas = document.querySelector('canvas');
        ctx = canvas.getContext('2d');

        text = text.split('');
        chars = chars.split('');
        charMap = [];
        offset = [];
        offsetV = [];

        for(var i=0;i<chars.length;i++){
          charMap[chars[i]] = i;
        }

        for(var i=0;i<text.length;i++){
          var f = firstLetter+delay*i;
          offsetV[text.length - i - 1] = endSpeed+breaks*f;
          offset[text.length - i - 1] = -(1+f)*(breaks*f+2*endSpeed)/2;
        }

        var black_letters_config = "700 30px Harmonia Sans";
        var pink_letters_config = "700 18px Harmonia Sans";

        function resizeCanvas()
        {
          if (window.innerWidth < 540) {
            scale = 40;
            canvas.width = 250;
            canvas.height = 100;
            black_letters_config = "700 30px Harmonia Sans";
            pink_letters_config = "700 18px Harmonia Sans";
          } else if (window.innerWidth >= 540 && window.innerWidth < 1101)
          {
            scale = 60;
            canvas.width = 360;
            canvas.height = 155;
            black_letters_config = "700 36px Harmonia Sans";
            pink_letters_config = "700 22px Harmonia Sans";
          } else {
            scale = 100;
            canvas.width = 600;
            canvas.height = 300;
            black_letters_config = "700 58px Harmonia Sans";
            pink_letters_config = "700 38px Harmonia Sans";
          }
        }
        
        (onresize = function(){
          resizeCanvas();
        })();

        resizeCanvas();

        requestAnimationFrame(loop = function(){
          ctx.setTransform(1,0,0,1,0,0);
          ctx.clearRect(0,0,canvas.width,canvas.height);
          ctx.globalAlpha = 1;
          ctx.fillStyle = 'transparent';
          //ctx.fillRect(0,(canvas.height-scale)/2,canvas.width,scale);
          ctx.strokeStyle='#f9589d';
          ctx.lineWidth=2;

          ctx.shadowColor = "#f9589d";
          ctx.shadowBlur = 10;
          
          let slot_spacing = scale/3;
          let rect_height = scale * 1.35;
          let rect_y = (canvas.height - rect_height) / 2;
          let subsquare_width = (canvas.width - 5*slot_spacing)/4;
          let bso = 3; // "Bigger subsquare offset"
          
          ctx.strokeRect (slot_spacing, rect_y, subsquare_width, rect_height);
          ctx.strokeRect (slot_spacing - bso, rect_y - bso, subsquare_width + 2*bso, rect_height + 2*bso);
          
          ctx.strokeRect (2*slot_spacing + subsquare_width, rect_y, subsquare_width, rect_height);
          ctx.strokeRect (2*slot_spacing + subsquare_width - bso, rect_y -bso, subsquare_width + 2*bso, rect_height + 2*bso);
          
          ctx.strokeRect (3*slot_spacing + 2*subsquare_width, rect_y, subsquare_width, rect_height);
          ctx.strokeRect (3*slot_spacing + 2*subsquare_width - bso, rect_y -bso, subsquare_width + 2*bso, rect_height + 2*bso);
          
          ctx.strokeRect (4*slot_spacing + 3*subsquare_width, rect_y, subsquare_width, rect_height);
          ctx.strokeRect (4*slot_spacing + 3*subsquare_width - bso, rect_y -bso, subsquare_width + 2*bso, rect_height + 2*bso);

          ctx.shadowBlur = 0;
          
          for(var i=0;i<text.length;i++){
            ctx.fillStyle = '#333';
            ctx.textBaseline = 'middle';
            ctx.textAlign = 'center';
            //ctx.setTransform(1,0,0,1,Math.floor((canvas.width-scale*(text.length-1))/2),Math.floor(canvas.height/2));
            ctx.setTransform(1, 0, 0, 1, 0, Math.floor(canvas.height/2));
            var o = offset[text.length - i - 1];
            var o = offset[i];
            while(o<0)o++;
            o %= 1;
            var h = Math.ceil(canvas.height/2/scale)
            for(var j=-h;j<h;j++){
              var c = charMap[text[i]]+j-Math.floor(offset[i]);
              while(c<0)c+=chars.length;
              c %= chars.length;

              if (j == 0 && o == 0){
                ctx.fillStyle = '#333';
                ctx.font = black_letters_config;
              }
              else {
                ctx.fillStyle = "#f7d4e3";
                ctx.font = pink_letters_config;
              }

              var s = 1-Math.abs(j+o)/(canvas.height/2/scale+1)
              ctx.globalAlpha = s
              //ctx.font = scale*s + 'px Harmonia Sans'
              //ctx.font = '700 32px Harmonia Sans'
              //ctx.fillText(chars[c],scale*i,(j+o)*scale);
              ctx.fillText(chars[c], (i + 1)*slot_spacing + i*subsquare_width + subsquare_width/2,(j+o)*scale*0.50);
            }
            offset[i] += offsetV[i];
            offsetV[i] -= breaks;
            if(offsetV[i]<endSpeed){
              offset[i] = 0;
              offsetV[i] = 0;
            }
          }

          requestAnimationFrame(loop);
        });

        // END SLOTBOX ANIMATION

        console.log(text);
        $('#codeValue').html(text);
        $("#codebox").hide();
        $("#slotbox").show().css({"visibility": "visible", "height": "fit-content" });

        if (text.length == 0)
        {
          document.getElementById ("slotbox").style.display = "none";
        }

      }
    });   
    
    ev.preventDefault(); // to stop the form from submitting
    
    //$("html, body").animate({ scrollTop: 340 }, "slow");

  });
  
  $('#slotbox').submit(function(ev) {  
    ev.preventDefault(); // to stop the form from submitting
    window.open('https://www.facebook.com/sharer/sharer.php?u=https%3A//www.facebook.com/RoyalEssenceCo/','',' scrollbars=no,menubar=no,resizable=yes,width=300,toolbar=no,location=no,status=no');
  });
});

function hideMinistars (star_nodes)
{
  for (let i = 0; i < star_nodes.length; i++)
  {
    star_nodes[i].style.animationName = "none";
    
    star_nodes[i].style.opacity = 0;
  }
}

document.addEventListener ("DOMContentLoaded", e => 
{
  const ministars = document.getElementsByClassName ("ministar-vault-box");
  const vault_box_arm_img = document.getElementById ("vault-box-arm");
  const appraisal_submit_btn = document.querySelector ("#appraisalForm .appraisal-submit");
  appraisal_submit_btn.addEventListener ("click", e => 
  {
    hideMinistars (ministars);
    vault_box_arm_img.classList.add ("turned-down");
  });
});